var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import PropTypes from "prop-types";
import React from "react";

import { DEFAULT_TAB_ACTIVE_STYLES, DEFAULT_TAB_STYLES } from "../../constants.js";

var Tab = function Tab(_ref) {
  var active = _ref.active,
      activeClassName = _ref.activeClassName,
      activeStyle = _ref.activeStyle,
      className = _ref.className,
      color = _ref.color,
      label = _ref.label,
      onClick = _ref.onClick,
      style = _ref.style,
      props = _objectWithoutProperties(_ref, ["active", "activeClassName", "activeStyle", "className", "color", "label", "onClick", "style"]);

  var classNames = [].concat(className ? className : [], active && activeClassName ? activeClassName : []);
  return React.createElement(
    "div",
    _extends({
      className: classNames.join(" "),
      onClick: onClick,
      style: _extends({}, style, color ? { color: color } : {}, active ? activeStyle : {}, active && color ? { background: color } : {})
    }, props),
    label
  );
};
Tab.propTypes = process.env.NODE_ENV !== "production" ? {
  active: PropTypes.bool,
  activeClassName: PropTypes.string,
  activeStyle: PropTypes.object,
  className: PropTypes.string,
  color: PropTypes.string,
  label: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object
} : {};

Tab.defaultProps = {
  active: false,
  activeClassName: "active",
  activeStyle: DEFAULT_TAB_ACTIVE_STYLES,
  className: null,
  color: null,
  label: "",
  onClick: null,
  style: DEFAULT_TAB_STYLES
};

export default Tab;